<template>
  <div class="budget-bid-wrap">
    <div class="card-header">预算与出价</div>
    <div class="modal-body" v-if="adCount.length > 0">
      <ul class="modal-form">
        <el-form :model="curFormData" :rules="rules" ref="formRef">
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">广告预算 ：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.adBudgetMode">
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">指定日预算</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-if="curFormData.adBudgetMode === 'BUDGET_MODE_DAY'" style="margin-bottom: 0px">
            <span class="form-label"></span>
            <div class="form-value">
              <el-form-item prop="dailyBudget">
                <el-input style="width: 264px" placeholder="(必填) 50元 - 40,000,000元" v-model="curFormData.dailyBudget">
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">计费方式 ：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.bidMode" @change="changeBidMode">
                <el-radio label="OCPM">oCPM</el-radio>
                <el-radio label="OCPC" v-if="draftAdset.placementType === 'AUTO'">oCPC</el-radio>
                <el-radio label="CPM" v-else>CPM</el-radio>
              </el-radio-group>
            </div>
          </li>
          <div v-if="curFormData.bidMode !== 'CPM'">
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px">优化目标 ：</span>
              <div class="form-value">
                <el-form-item prop="optimizationGoal">
                  <el-select v-model="curFormData.optimizationGoal" @change="changeOptimizationGoal">
                    <el-option v-for="item in optimalObjectList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">出价类型 ：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.smartBidType">
                  <el-radio label="CUSTOM">手动出价</el-radio>
                  <el-radio label="SYSTEMATIC" :disabled="curFormData.adBudgetMode === 'BUDGET_MODE_INFINITE'">自动出价</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">出价策略 ：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.bidStrategy">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="在选择了竞价策略为“稳定拿量”后，系统将尽可能稳定成本，使转化成本能够接近您预设的出价。"
                    placement="top"
                  >
                    <el-radio label="AVERAGE_COST">稳定拿量</el-radio>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="在选择了竞价策略为“优先拿量”后，系统将为您的广告争取尽可能多的转化量，并在必要时提高竞价。"
                    placement="top"
                  >
                    <el-radio label="TARGET_COST">优先拿量</el-radio>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="产品策略更新，仅手动出价可用，系统会尽可能下探实际成本，使其在不超过出价上限的基础上，获取更多转化。"
                    placement="top"
                  >
                    <el-radio label="PRIORITY_LOW_COST" :disabled="!isBidTypeManual">控制成本上限</el-radio>
                  </el-tooltip>
                </el-radio-group>
              </div>
            </li>
          </div>

          <!-- 受出价类型影响 -->
          <div v-if="isBidTypeManual">
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">出价模式 ：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.bidPattern">
                  <el-radio label="FIX">固定出价</el-radio>
                  <!-- <el-radio label="LADDER">阶梯出价</el-radio> -->
                </el-radio-group>
              </div>
            </li>

            <li class="form-item" style="margin-bottom: 0px" v-if="curFormData.bidPattern === 'FIX'">
              <span class="form-label" style="padding-top: 6px">出价：</span>
              <div class="form-value">
                <el-form-item prop="bidAmount">
                  <el-input
                    style="width: 264px"
                    @input="(value) => value.replace(/[^1-9]{0,1}(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                    v-model="curFormData.bidAmount"
                  >
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>

            <li class="form-item" style="margin-bottom: 0px" v-else>
              <span class="form-label" style="padding-top: 0px">出价范围：</span>
              <div class="form-value" style="display: flex">
                <el-form-item prop="minBidPrice">
                  <el-input style="width: 180px" placeholder="最小值" v-model="curFormData.minBidPrice">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
                <div style="margin: 0 12px;display: inline-block">-</div>
                <el-form-item prop="maxBidPrice">
                  <el-input style="width: 180px" placeholder="最大值" v-model="curFormData.maxBidPrice">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>

            <li
              class="form-item"
              style="margin:-12px 0"
              v-if="curFormData.bidMode !== 'CPM' && ['APP_ACTIVATE', 'APP_REGISTER'].includes(curFormData.optimizationGoal)"
            >
              <span class="form-label" style="padding-top: 12px">深度优化 ：</span>
              <div class="form-value">
                <el-form-item prop="enableDeepOptimization">
                  <el-switch v-model="curFormData.enableDeepOptimization"> </el-switch>
                </el-form-item>
              </div>
            </li>
          </div>

          <!-- 受深度优化开关影响 -->
          <div v-if="curFormData.enableDeepOptimization && curFormData.bidMode !== 'CPM' && isBidTypeManual">
            <li class="form-item">
              <span class="form-label">深度优化类型：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.deepOptimization.deepConversionType">
                  <el-radio label="BEHAVIOR">优化转化行为</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px">深度优化目标 ：</span>
              <div class="form-value">
                <el-select v-model="curFormData.deepOptimization.deepOptimizationGoal">
                  <el-option v-for="item in deepOptimalObjectList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">深度出价模式 ：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.deepOptimization.deepBidPattern">
                  <el-radio label="FIX">固定出价</el-radio>
                  <!-- <el-radio label="LADDER">阶梯出价</el-radio> -->
                </el-radio-group>
              </div>
            </li>
            <div v-if="curFormData.deepOptimization.deepBidPattern === 'FIX'">
              <li class="form-item" style="margin-bottom: 0px">
                <span class="form-label" style="padding-top: 6px">深度目标出价：</span>
                <div class="form-value">
                  <el-form-item prop="deepOptimization">
                    <el-input
                      style="width: 264px"
                      @input="(value) => value.replace(/[^1-9]{0,1}(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      v-model="curFormData.deepOptimization.deepConversionBehaviorBid"
                    >
                      <template slot="append">CNY</template>
                    </el-input>
                  </el-form-item>
                </div>
              </li>
              <div
                style="font-size:8px;margin-left: 120px;color: rgba(0, 0, 0, 0.45);margin-top: -12px"
                v-if="
                  curFormData.bidAmount &&
                    curFormData.deepOptimization.deepConversionBehaviorBid &&
                    !isNaN(curFormData.bidAmount / curFormData.deepOptimization.deepConversionBehaviorBid)
                "
              >
                当前的激活次留率目标为{{ (curFormData.bidAmount / curFormData.deepOptimization.deepConversionBehaviorBid) * 100 }}%
              </div>
            </div>

            <li class="form-item" style="margin-bottom: 0px" v-else>
              <span class="form-label" style="padding-top: 0px">深度出价范围：</span>
              <div class="form-value" style="display: flex">
                <el-form-item prop="deepMinBidPrice">
                  <el-input style="width: 180px" placeholder="最小值" v-model="curFormData.deepMinBidPrice">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
                <div style="margin: 0 12px;display: inline-block">-</div>
                <el-form-item prop="deepMaxBidPrice">
                  <el-input style="width: 180px" placeholder="最大值" v-model="curFormData.deeppMaxBidPrice">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
          </div>

          <li class="form-item">
            <span class="form-label" style="padding-top: 6px">开始日期 ：</span>
            <div class="form-value">
              <el-form-item prop="beginTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  v-model="curFormData.beginTime"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
                （GMT+08:00）
              </el-form-item>
            </div>
          </li>

          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">结束日期 ：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.endTimeMode">
                <el-radio label="LONG_TIME">长期投放</el-radio>
                <el-radio label="CUSTOM_TIME">自定义投放时间</el-radio>
              </el-radio-group>
              （GMT+08:00）
            </div>
          </li>

          <li class="form-item" v-if="curFormData.endTimeMode === 'CUSTOM_TIME'">
            <span class="form-label" style="padding-top: 0px"></span>
            <div class="form-value">
              <el-form-item prop="endTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  v-model="curFormData.endTime"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </li>

          <li class="form-item">
            <span class="form-label">投放时段：</span>
            <el-form-item prop="timeSeriesMode">
              <div class="form-value">
                <el-radio-group v-model="curFormData.timeSeriesMode">
                  <el-radio label="0">全天投放</el-radio>
                  <el-radio label="1">自定义多个时段</el-radio>
                </el-radio-group>
                <div class="time-range-wrap" v-show="curFormData.timeSeriesMode === '1'">
                  <time-table ref="timeTableRef"></time-table>
                </div>
              </div>
            </el-form-item>
          </li>

          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">首日开始时间 ：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.firstDayTimeMode">
                <el-radio label="NOLIMIT">不限</el-radio>
                <el-radio label="CUSTOM">自定义</el-radio>
              </el-radio-group>
            </div>
          </li>

          <li class="form-item" v-if="curFormData.firstDayTimeMode === 'CUSTOM'">
            <span class="form-label" style="padding-top: 0px"></span>
            <div class="form-value">
              <el-select v-model="curFormData.firstDayBeginTime">
                <el-option v-for="item of dayTimeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </li>

          <li class="form-item" style="margin:-12px 0" v-if="isShowByPlateBidMode">
            <span class="form-label" style="padding-top: 12px">分版位出价 ：</span>
            <div class="form-value">
              <el-form-item>
                <el-switch v-model="curFormData.byPlateBidMode"> </el-switch>
              </el-form-item>
            </div>
          </li>
          <li class="form-item" v-if="curFormData.byPlateBidMode && isShowByPlateBidMode">
            <span class="form-label" style="padding-top: 12px"></span>
            <div class="form-value">
              <el-table :data="curFormData.bidAdjustments" style="width: 702px" border size="mini">
                <el-table-column prop="group" label="分组">
                  <template slot-scope="scope">
                    <div v-for="item in scope.row.siteSet" :key="item">{{ transferSiteKeyToLabel(item) }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="浅层出价系数" width="250">
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.bidCoefficient"
                      size="small"
                      :precision="1"
                      step-strictly
                      :min="0.5"
                      :max="1.5"
                      :step="0.1"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="深度出价系数"
                  width="250"
                  v-if="curFormData.enableDeepOptimization && curFormData.bidMode !== 'CPM' && isBidTypeManual"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.deepBidCoefficient"
                      size="small"
                      :precision="1"
                      step-strictly
                      :min="0.5"
                      :max="1.5"
                      :step="0.1"
                    ></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
              <el-button style="margin-top: 8px" @click="changePlatGroup">修改版位组合</el-button>
            </div>
          </li>
          <div v-if="curFormData.bidMode !== 'CPM'">
            <li class="form-item" style="margin:-12px 0" v-if="isBidTypeManual">
              <span class="form-label" style="padding-top: 12px">一键起量 ：</span>
              <div class="form-value">
                <el-form-item>
                  <el-switch v-model="curFormData.autoAcquisitionEnabled"> </el-switch>
                </el-form-item>
              </div>
            </li>
            <li class="form-item" style="margin:-12px 0" v-if="curFormData.autoAcquisitionEnabled && isBidTypeManual">
              <span class="form-label" style="padding-top: 12px">起量预算 ：</span>
              <div class="form-value">
                <el-form-item prop="autoAcquisitionBudget">
                  <el-input style="width: 264px" placeholder="建议设置为出价的10倍" v-model="curFormData.autoAcquisitionBudget"> </el-input>
                </el-form-item>
              </div>
            </li>
          </div>
        </el-form>
      </ul>
    </div>
    <div class="empty-content" v-else>请先选账户</div>
    <el-dialog title="修改版位组合" :close-on-click-modal="false" :visible.sync="dialogVisible" width="25%">
      <div v-for="(item, index) in groupList" :key="index" class="dialog-group">
        <div class="dialog-title" v-if="item.siteSet.length > 0">组合{{ index + 1 }}</div>
        <div class="dialog-title" v-else>新增组合</div>
        <div class="dialog-content">
          <vue-draggable v-model="item.siteSet" group="site" animation="300" @start="onStart" @end="onEnd">
            <transition-group style="min-height:32px;display: block">
              <div class="item" v-for="child in item.siteSet" :key="child">
                <img class="sort-icon" src="@/assets/menu.png" />
                {{ transferSiteKeyToLabel(child) }}
              </div>
            </transition-group>
          </vue-draggable>
          <div v-if="item.siteSet.length === 0" class="add-item">
            <div><i class="el-icon-plus"></i></div>
            拖拽到此处新增组合
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSaveGroup">取 消</el-button>
        <el-button type="primary" @click="confirmSaveGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TimeTable from "@/components/timeTable.vue";
import { mapState } from "vuex";
import {
  optimalObjectList,
  validateMoney,
  pickerOptions,
  dayTimeList,
  deepOptimalObjectList,
  getAllTimeSeries,
  videoSelectListOptions,
  gameSelectListOptions,
  transferSiteKeyToLabel,
} from "./common/config";
import VueDraggable from "vuedraggable";

export default {
  components: {
    TimeTable,
    VueDraggable,
  },
  data() {
    return {
      videoSelectListOptions,
      gameSelectListOptions,
      getAllTimeSeries,
      transferSiteKeyToLabel,
      optimalObjectList,
      deepOptimalObjectList,
      pickerOptions,
      dayTimeList,
      tableData: [],
      curFormData: {
        adBudgetMode: "BUDGET_MODE_INFINITE",
        dailyBudget: "",
        bidMode: "OCPM",
        optimizationGoal: "",
        smartBidType: "CUSTOM",
        bidStrategy: "AVERAGE_COST",
        bidPattern: "FIX",
        bidAmount: "",
        // minBidPrice: "",
        // maxBidPrice: "",
        bidAdjustments: [],
        enableDeepOptimization: false,
        deepOptimization: {
          deepConversionType: "BEHAVIOR",
          deepOptimizationGoal: "APP_PURCHASE",
          deepBidPattern: "FIX",
          deepConversionBehaviorBid: "",
        },
        // deepMinBidPrice: "",
        // deeppMaxBidPrice: "",
        beginTime: "",
        endTimeMode: "LONG_TIME",
        endTime: "",
        firstDayTimeMode: "NOLIMIT",
        firstDayBeginTime: "",
        selectDate: [], //接口为start_time end_time
        timeSeriesMode: "0", //投放时间段 0不限 1指定时间段
        timeSeries: "",
        byPlateBidMode: false,
        autoAcquisitionEnabled: false,
        autoAcquisitionBudget: "",
      },
      dialogVisible: false,
      drag: false,
      groupList: [],
      newArr: [],
      rules: {
        optimizationGoal: [{ required: true, message: "请选择优化目标", trigger: "blur" }],
        dailyBudget: [
          {
            validator: validateMoney,
            trigger: ["blur"],
          },
          {
            validator: (rule, value, callback) => {
              if (Number(value) < 50 || Number(value) > 40000000) {
                callback(new Error("请输入不小于50,不大于40000000的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        bidAmount: [
          { validator: validateMoney, trigger: ["blur"] },
          {
            validator: (rule, value, callback) => {
              if (this.isQQShop) {
                (Number(value) < 20 || Number(value) > 999) && this.curFormData.bidMode === "CPM"
                  ? callback(new Error("出价限制20 元-999 元"))
                  : callback();
              } else {
                if ((Number(value) < 1.5 || Number(value) > 999) && this.curFormData.bidMode === "CPM") {
                  callback(new Error("出价限制1.5 元-999 元"));
                } else if ((Number(value) < 0.1 || Number(value) > 5000) && this.curFormData.bidMode !== "CPM") {
                  callback(new Error("出价限制0.1 元-5000 元"));
                } else {
                  callback();
                }
              }
            },
            trigger: ["blur"],
          },
        ],
        timeSeriesMode: [
          {
            validator: (rule, value, callback) => {
              if (this.curFormData.timeSeriesMode === "1" && !this.$refs.timeTableRef.checkedValue.includes(1)) {
                callback(new Error("请至少选择一个时段"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        beginTime: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请设置开始日期"));
              } else if (this.curFormData.endTime && this.curFormData.endTime < value) {
                callback(new Error("开始日期不能大于结束日期"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        endTime: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请设置结束日期"));
              } else if (this.curFormData.beginTime && this.curFormData.beginTime > value) {
                callback(new Error("开始日期不能大于结束日期"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        maxBidPrice: [
          { validator: validateMoney, trigger: ["blur"] },
          {
            validator: (rule, value, callback) => {
              if (this.curFormData.minBidPrice && this.curFormData.minBidPrice > value) {
                callback(new Error("最低价必须小于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        minBidPrice: [
          { validator: validateMoney, trigger: ["blur", "change"] },
          {
            validator: (rule, value, callback) => {
              if (this.curFormData.maxBidPrice && value > this.curFormData.maxBidPrice) {
                callback(new Error("最低价必须小于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        deepOptimization: [
          {
            validator: (rule, value, callback) => {
              if (!value.deepConversionBehaviorBid) {
                callback(new Error("不能为空"));
              } else if (!/^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value.deepConversionBehaviorBid)) {
                callback(new Error("请输入至多保留2位小数的正数！"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        deeppMaxBidPrice: [
          { validator: validateMoney, trigger: ["blur", "change"] },
          {
            validator: (rule, value, callback) => {
              if (this.curFormData.deepMinBidPrice && this.curFormData.deepMinBidPrice > value) {
                callback(new Error("最低价必须小于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        deepMinBidPrice: [
          { validator: validateMoney, trigger: ["blur", "change"] },
          {
            validator: (rule, value, callback) => {
              if (this.curFormData.deeppMaxBidPrice && value > this.curFormData.deeppMaxBidPrice) {
                callback(new Error("最低价必须小于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        autoAcquisitionBudget: [
          {
            validator: validateMoney,
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (Number(value) < 200 || Number(value) > 100000) {
                callback(new Error("请输入不小于200,不大于100000的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    //格式化单条表单数据
    formatData(storeData) {
      storeData.budget === "" && (storeData.budget = null);
      // delete storeData.itemId;
      delete storeData.selectDate;
      //投放时间段
      if (storeData.timeSeriesMode === "0") {
        let str = "1";
        for (let i = 0; i < 48 * 7 - 1; i++) {
          str += "1";
        }
        storeData.timeSeriesMode = str;
      } else {
        storeData.timeSeriesMode = storeData.timeSeries;
      }
      delete storeData.timeSeries;
    },
    transforApiToForm(item) {
      // item.itemId = Math.random();
      //投放时间段
      let str = "1";
      for (let i = 0; i < 48 * 7 - 1; i++) {
        str += "1";
      }
      item.timeSeries = item.timeSeriesMode;
      if (item.timeSeriesMode === str) {
        item.timeSeriesMode = "0";
      } else {
        item.timeSeriesMode = "1";
      }
    },
    changeOptimizationGoal() {
      if (!["APP_ACTIVATE", "APP_REGISTER"].includes(this.curFormData.optimizationGoal)) {
        this.curFormData.enableDeepOptimization = false;
      }
    },
    changeBidMode() {
      if (this.curFormData.bidMode === "CPM") {
        this.curFormData.enableDeepOptimization = false;
        this.curFormData.autoAcquisitionEnabled = false;
        this.curFormData.autoAcquisitionBudget = "";
      }
    },
    changePlatGroup() {
      this.groupList = JSON.parse(JSON.stringify(this.curFormData.bidAdjustments));
      let allPlat = [];
      this.groupList.map((item) => {
        allPlat = allPlat.concat(item.siteSet);
      });
      if (this.groupList.length < allPlat.length) {
        this.groupList.push({ siteSet: [] });
      }
      this.dialogVisible = true;
    },
    confirmSaveGroup() {
      this.curFormData.bidAdjustments = [];
      this.groupList.map((item) => {
        if (item.siteSet.length !== 0) {
          this.curFormData.bidAdjustments.push({ siteSet: item.siteSet, bidCoefficient: "", deepBidCoefficient: "" });
        }
      });
      this.dialogVisible = false;
    },
    cancelSaveGroup() {
      this.groupList = [];
      this.dialogVisible = false;
    },
    onStart() {
      this.drag = true;
    },
    onEnd() {
      this.drag = false;
      let allPlat = [];
      const len = this.groupList.length - 1;
      for (var i = len; i >= 0; i--) {
        if (this.groupList[i].siteSet.length === 0) {
          this.groupList.splice(i, 1);
        } else {
          allPlat = allPlat.concat(this.groupList[i].siteSet);
        }
      }
      if (this.groupList.length < allPlat.length) {
        this.groupList.push({ siteSet: [] });
      }
    },
    //保存模板时不校验，直接保存
    saveData() {
      const data = JSON.parse(JSON.stringify(this.curFormData));
      const {
        adBudgetMode,
        dailyBudget,
        bidMode,
        bidAmount,
        optimizationGoal,
        enableDeepOptimization,
        endTimeMode,
        endTime,
        timeSeriesMode,
        firstDayTimeMode,
        firstDayBeginTime,
        autoAcquisitionBudget,
        byPlateBidMode,
        bidAdjustments,
      } = data;
      data.dailyBudget = adBudgetMode === "BUDGET_MODE_INFINITE" ? 0 : dailyBudget * 100;
      data.bidAmount = bidAmount * 100;
      if (bidMode === "CPM") {
        delete data.optimizationGoal;
      }
      if (!["APP_ACTIVATE", "APP_REGISTER"].includes(optimizationGoal)) {
        data.enableDeepOptimization = false;
      }
      if (!enableDeepOptimization) {
        data.deepOptimization.deepConversionBehaviorBid = null;
        delete data.deepOptimization.deepOptimizationGoal;
      }
      data.deepOptimization.deepConversionBehaviorBid = data.deepOptimization.deepConversionBehaviorBid
        ? data.deepOptimization.deepConversionBehaviorBid * 100
        : data.deepOptimization.deepConversionBehaviorBid;
      data.endTime = endTimeMode === "LONG_TIME" ? "" : endTime;
      this.$nextTick(() => {
        data.timeSeries = timeSeriesMode === "0" ? this.getAllTimeSeries() : this.$refs.timeTableRef.checkedValue.join("");
      });
      data.firstDayBeginTime = firstDayTimeMode === "NOLIMIT" ? null : firstDayBeginTime;
      data.autoAcquisitionBudget = autoAcquisitionBudget * 100;
      data.byPlateBidMode = this.isShowByPlateBidMode ? byPlateBidMode : false;
      data.bidAdjustments = this.isShowByPlateBidMode && byPlateBidMode ? bidAdjustments : null;
      this.$store.commit("set_draft_budgets_gdt", data);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
  },
  computed: {
    ...mapState({
      templateDetail: (state) => state.PromotionGdt.templateDetail,
      origin_draft_budgets: (state) => state.PromotionGdt.origin_draft_budgets,
      adCount: (state) => state.PromotionGdt.adCount || [],
      promote_object: (state) => state.PromotionGdt.draft_adset || {},
      draftAdset: (state) => state.PromotionGdt.draft_adset,
    }),
    // 出价类型是否为手动出价
    isBidTypeManual() {
      return !(this.curFormData.smartBidType === "SYSTEMATIC" && this.curFormData.bidMode !== "CPM");
    },
    /*  是否展示分版位出价
      不展示情况：广告版位等于 按媒体选择且选择的类目小于2
    */
    isShowByPlateBidMode() {
      const { placementType, videoCheckList, gameCheckList } = this.promote_object || {};
      return !placementType ||
        (placementType === "VIDEO" && videoCheckList.length < 2) ||
        (placementType === "GAME" && gameCheckList.length < 2) ||
        this.curFormData.bidMode === "CPM"
        ? false
        : true;
    },
    isQQShop() {
      return (
        this.draftAdset.placement &&
        this.draftAdset.placement.siteSet?.length === 1 &&
        this.draftAdset.placement.siteSet[0] === "SITE_SET_QQSHOPPING"
      );
    },
    versionList() {
      const { placementType, videoCheckList, gameCheckList } = this.promote_object || {};
      return {
        placementType,
        videoCheckList,
        gameCheckList,
      };
    },
  },
  watch: {
    versionList: {
      handler(val, oldV) {
        const { placementType: newType, videoCheckList: newVideo, gameCheckList: newGame } = JSON.parse(JSON.stringify(val || {}));
        const { placementType: oldType, videoCheckList: oldVideo, gameCheckList: oldGame } = JSON.parse(JSON.stringify(oldV || {}));
        if (
          !(newVideo?.length === oldVideo?.length && newVideo?.sort().toString() === oldVideo?.sort().toString()) ||
          !(newGame?.length === oldGame?.length && newGame?.sort().toString() === oldGame?.sort().toString()) ||
          newType !== oldType
        ) {
          const { placementType, videoCheckList, gameCheckList } = val || {};
          this.curFormData.bidAdjustments = [];
          const otherGroup = ["SITE_SET_KANDIAN", "SITE_SET_QQ_MUSIC_GAME", "SITE_SET_TENCENT_NEWS", "SITE_SET_TENCENT_VIDEO"];
          // 自动版位
          if (placementType === "AUTO") {
            this.curFormData.bidAdjustments = [
              {
                siteSet: otherGroup,
                bidCoefficient: "",
                deepBidCoefficient: "",
              },
              { siteSet: ["SITE_SET_MOBILE_UNION"], bidCoefficient: "", deepBidCoefficient: "" },
              // { siteSet: ["SITE_SET_WECHAT"], bidCoefficient: "", deepBidCoefficient: "" },
            ];
          } else if (placementType === "GAME") {
            if (gameCheckList.length > 1) {
              gameCheckList.map((item) => {
                this.curFormData.bidAdjustments.push({
                  siteSet: [item],
                  bidCoefficient: "",
                  deepBidCoefficient: "",
                });
              });
            }
          } else {
            if (videoCheckList.length > 1) {
              const sameSite = Array.from(new Set([...new Set(videoCheckList)].filter((x) => new Set(otherGroup).has(x))));
              this.curFormData.bidAdjustments = [
                {
                  siteSet: sameSite,
                  bidCoefficient: "",
                  deepBidCoefficient: "",
                },
              ];
            }
            if (videoCheckList.includes("SITE_SET_MOBILE_UNION")) {
              this.curFormData.bidAdjustments.push({
                siteSet: ["SITE_SET_MOBILE_UNION"],
                bidCoefficient: "",
                deepBidCoefficient: "",
              });
            }
            if (videoCheckList.includes("SITE_SET_WECHAT")) {
              this.curFormData.bidAdjustments.push({
                siteSet: ["SITE_SET_WECHAT"],
                bidCoefficient: "",
                deepBidCoefficient: "",
              });
            }
          }
        }
      },
      immediate: true,
    },
    curFormData: {
      handler() {
        this.saveData();
      },
      deep: true,
      immediate: true,
    },
    origin_draft_budgets: {
      handler(val) {
        const storeData = JSON.parse(JSON.stringify(val));
        const { dailyBudget, bidAmount, autoAcquisitionBudget, timeSeriesMode, timeSeries } = storeData;
        storeData.dailyBudget = dailyBudget / 100;
        storeData.bidAmount = bidAmount / 100;
        storeData.autoAcquisitionBudget = autoAcquisitionBudget / 100;
        storeData.deepOptimization.deepConversionBehaviorBid = storeData.deepOptimization.deepConversionBehaviorBid
          ? storeData.deepOptimization.deepConversionBehaviorBid / 100
          : storeData.deepOptimization.deepConversionBehaviorBid;
        if (timeSeriesMode === "0") {
          this.$nextTick(() => {
            this.$refs.timeTableRef && this.$refs.timeTableRef.clearSelect();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.timeTableRef?.showSelectNode(timeSeries.split("").map((item) => Number(item)));
          });
        }
        this.curFormData = storeData;
      },
    },
    "draftAdset.placementType": {
      handler() {
        if (this.curFormData.bidMode !== "OCPM") {
          this.curFormData.bidMode = "OCPM";
        }
      },
    },
    "curFormData.smartBidType": {
      handler(val) {
        if (this.curFormData.bidStrategy === "PRIORITY_LOW_COST" && val === "SYSTEMATIC") this.curFormData.bidStrategy = "AVERAGE_COST";
      },
    },
  },
};
</script>

<style lang="less" scoped>
.budget-bid-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .modal-body {
    padding-top: 10px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 120px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .down-wrap {
            cursor: pointer;
          }
          .data-range {
            margin-top: 10px;
            position: relative;
            /deep/.el-range__icon {
              position: absolute;
              right: 6px;
              top: 0px;
            }
            /deep/.el-range-separator {
              line-height: 24px;
              color: rgba(0, 0, 0, 0.25);
            }
          }
          .time-range-wrap {
            margin-top: 10px;
            border: 1px solid #eee;
            padding-bottom: 14px;
          }
        }
      }
    }
    .footer-wrap {
      display: block;
      text-align: right;
    }
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
  .dialog-group {
    width: 350px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .dialog-title {
      width: 100px;
    }
    .dialog-content {
      border: 1px solid #eee;
      border-radius: 4px;
      min-height: 32px;
      width: 100%;
    }
    .item {
      padding: 0 5px;
      line-height: 32px;
      border-bottom: 1px solid #eee;
      .sort-icon {
        margin: -2px 10px;
        width: 14px;
        height: 14px;
      }
    }
    .add-item {
      line-height: 24px;
      text-align: center;
      position: relative;
      top: -15px;
      .el-icon-plus {
        font-size: 18px;
      }
    }
    .item:last-child {
      border-bottom: none;
    }
  }
}
</style>
